@done = 'done'

#resource types
@rt =
    website: 'website'
    chat:    'chat/im'
    gaming:  'gaming'
    email:   'email'
    query:   'query'

#form suspicions
@CP = 'CP'
@CG = 'CG'
@FS = 'FS'
@RX = 'RX'
@QU = 'QU'
@IA = 'IA'
@SB = 'SB' # sextortion/blackmailing

## step labels below
@imageryTakenUnderage     = "imageryTakenUnderage"
@whoIsFeatured            = "whoIsFeatured"
@relationship             = "relationship"
@ageNow                   = "ageNow"
@gender                   = "gender"
@didYouConsentToTake      = "didYouConsentToTake"
@didYouConsentToShare     = "didYouConsentToShare"
@willingToTakeAction      = "willingToTakeAction"
@hasIncidentBeenReported  = "hasIncidentBeenReported"
@hasScreenshots           = "hasScreenshots"
@haveWeGardaConsent       = "haveWeGardaConsent"
@doYouKnowPerpetrator     = "doYouKnowPerpetrator"
@victimLocation           = "victimLocation"
## IA form fields without a question wrap
@gardaCaseId              = "gardaCaseId"
@victimDob                = 'victimDob'
@gardaDistrict            = 'gardaDistrict'
@gardaStation             = 'gardaStation'
@preferredMeans           = 'preferredMeans'
@preferredTime            = 'preferredTime'
@pgFirstName              = 'pgFirstName'
@pgLastName               = 'pgLastName'
@pgEmail                  = 'pgEmail'
@pgPhone                  = 'pgPhone'

## answer labels below
@unspecified          = 'unspecified'
@underAgeImagery      = 'underAgeImagery'
@overAgeImagery       = 'overAgeImagery'
@myself               = 'myself'
@other                = 'other'
@guardianUnderage     = 'guardianUnderage'
@guardianIncapable    = 'guardianIncapable'
@unrelated            = 'unrelated'
@u18                  = 'u18'
@f18t24               = 'f18t24'
@f25t34               = 'f25t34'
@f35t44               = 'f35t44'
@o44                  = 'o44'
@female               = 'female'
@male                 = 'male'
@transgender          = 'transgender'
@diverse              = 'diverse'
@intersex             = 'intersex'
@preferNotToSay       = 'preferNotToSay'
@consentedToTake      = 'consentedToTake'
@notConsentedToTake   = 'notConsentedToTake'
@consentedToShare     = 'consentedToShare'
@notConsentedToShare  = 'notConsentedToShare'
@victimInIreland      = 'victimInIreland'
@perpetratorInIreland = 'perpetratorInIreland'
@bothInIreland        = 'bothInIreland'
@noneInIreland        = 'noneInIreland'
@legalAction          = 'legalAction'
@contentRemoved       = 'contentRemoved'
@beenReported         = 'beenReported'
@notReported          = 'notReported'
# @hasScreenshots       = 'hasScreenshots' # defined above
@noScreenshots        = 'noScreenshots'
@perpetratorKnown     = 'perpetratorKnown'
@perpetratorUnknown   = 'perpetratorUnknown'
@gardaConsentGiven    = 'gardaConsentGiven'
@noGardaConsentGiven  = 'noGardaConsentGiven'
@preferEmail          = 'preferEmail'
@preferPhone          = 'preferPhone'
